(() => {
  let dialog = null, trigger = null, bound = false;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const open = (from) => {
    if (!dialog) return;
    trigger = from || null;
    document.documentElement.classList.add('abm-cb-lock');
    dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-visible')));
    dialog.querySelector('input[name="contact[name]"], .abm-cb__close')?.focus({ preventScroll: true });
  };
  const close = () => {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-visible');
    const done = () => { dialog.close(); document.documentElement.classList.remove('abm-cb-lock'); trigger?.focus?.({ preventScroll: true }); };
    reduce() ? done() : setTimeout(done, 360);
  };

  const bind = () => {
    dialog = document.querySelector('[data-abm-callback-dialog]');
    if (!dialog || bound) return;
    bound = true;
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target.closest('[data-abm-callback-close]')) close(); });

    const form = dialog.querySelector('[data-abm-callback-form]');
    const success = dialog.querySelector('[data-abm-callback-success]');
    const errBox = dialog.querySelector('[data-abm-callback-error]');
    if (form) form.addEventListener('submit', (e) => {
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
      // Native submit so Shopify can attach its spam-protection token; the page returns with the success state.
      errBox.hidden = true;
      try { sessionStorage.setItem('abmFormPosted', form.id); } catch (_) {}
      form.querySelector('[type=submit]').setAttribute('aria-busy', 'true');
      requestAnimationFrame(() => { if (dialog.open && dialog.matches(':modal')) { dialog.close(); dialog.show(); dialog.classList.add('is-visible'); } });
    });
    // Shopify returns to "#<form id>"; ignore states that belong to another contact form on the page.
    let posted = null;
    try { posted = sessionStorage.getItem('abmFormPosted'); if (posted === form?.id) setTimeout(() => { try { sessionStorage.removeItem('abmFormPosted'); } catch (_) {} }, 3000); } catch (_) {}
    const mine = posted ? posted === form?.id : (!location.hash || location.hash === `#${form?.id}`);
    if (!mine) { success?.setAttribute('hidden', ''); errBox?.setAttribute('hidden', ''); }
    else if (success && success.hasAttribute('data-just-sent')) { form.hidden = true; open(null); }
    else if (errBox && !errBox.hidden) open(null);
  };

  const isTrigger = (el) => el.matches('[data-abm-callback]') || /#(request-call|callback)$/.test(el.getAttribute('href') || '');
  document.addEventListener('click', (e) => {
    const el = e.target.closest('a, button');
    if (!el || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (dialog && dialog.contains(el)) return;
    if (!isTrigger(el)) return;
    e.preventDefault();
    bind();
    open(el);
  }, true);

  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:select', (e) => { bind(); if (dialog && e.target.contains(dialog)) open(null); });
  document.addEventListener('shopify:section:deselect', (e) => { if (dialog && e.target.contains(dialog)) close(); });
})();
